"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBPagination", {
  enumerable: true,
  get: function get() {
    return _SVBPagination.default;
  }
});
var _SVBPagination = _interopRequireDefault(require("./src/SVBPagination"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }